import {useCallback} from "react";
import {useUser} from "@/components/Providers/JWTProvider.tsx";

const useStripeCreateSetupIntent = (): (() => Promise<Response | void>) => {
    const {user} = useUser();

    return useCallback(async (): Promise<Response | void> => {
        const url = new URL(
            "/v1/payment/create-setup-intent",
            import.meta.env.VITE_APP_API_ENDPOINT,
        );

        if (user) {
            return await user.apiFetch(url.toString(), {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });
        }
        console.error("missing user");
    }, []);
};

export default useStripeCreateSetupIntent;
